var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('Drawer', {
    staticClass: "CreateSemiItemDrawer",
    attrs: {
      "width": "400",
      "title": "母液项目"
    },
    model: {
      value: _vm.drawerOpened,
      callback: function ($$v) {
        _vm.drawerOpened = $$v;
      },
      expression: "drawerOpened"
    }
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('div', {
    staticClass: "drawer-content"
  }, [_c('Form', {
    ref: "formItem",
    attrs: {
      "label-position": "top",
      "rules": _vm.ruleValidate,
      "model": _vm.formItem
    },
    nativeOn: {
      "submit": function ($event) {
        $event.preventDefault();
      }
    }
  }, [_c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "母液",
      "prop": "material"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "loading": _vm.semiMaterialLoading,
      "placeholder": "选择母液",
      "disabled": _vm.openedSemiItem ? true : false,
      "clearable": ""
    },
    on: {
      "on-change": _vm.selectSemiChange
    },
    model: {
      value: _vm.formItem.material,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "material", $$v);
      },
      expression: "formItem.material"
    }
  }, _vm._l(_vm.semiMaterials, function (option) {
    return _c('Option', {
      key: option._id,
      staticStyle: {
        "width": "350px"
      },
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.model))]);
  }), 1)], 1), _c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "工厂",
      "prop": "factory"
    }
  }, [_c('Select', {
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "disabled": _vm.openedSemiItem ? true : false,
      "loading": _vm.factoryLoading,
      "placeholder": "选择工厂"
    },
    model: {
      value: _vm.formItem.factory,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "factory", $$v);
      },
      expression: "formItem.factory"
    }
  }, _vm._l(_vm.factoryList, function (option) {
    return _c('Option', {
      key: option._id,
      staticStyle: {
        "width": "350px"
      },
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "自产母液",
      "prop": "selfProductSemi"
    }
  }, [_c('i-switch', {
    on: {
      "on-change": _vm.changeSelfProductSemi
    },
    model: {
      value: _vm.isSelfProductSemi,
      callback: function ($$v) {
        _vm.isSelfProductSemi = $$v;
      },
      expression: "isSelfProductSemi"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "禁用",
      "prop": "invalid"
    }
  }, [_c('i-switch', {
    attrs: {
      "true-color": "#ff4949"
    },
    on: {
      "on-change": _vm.changeInvalid
    },
    model: {
      value: _vm.isInvalid,
      callback: function ($$v) {
        _vm.isInvalid = $$v;
      },
      expression: "isInvalid"
    }
  })], 1), _c('FormItem', {
    attrs: {
      "label": "金蝶云代码",
      "prop": "JDItemCode"
    }
  }, [_c('Input', {
    attrs: {
      "placeholder": "输入金蝶云代码..."
    },
    model: {
      value: _vm.formItem.JDItemCode,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "JDItemCode", $$v);
      },
      expression: "formItem.JDItemCode"
    }
  })], 1), !_vm.isSelfProductSemi ? _c('div', [_c('FormItem', {
    staticStyle: {
      "width": "366px"
    },
    attrs: {
      "label": "母液生产的工厂",
      "prop": "fromFactory"
    }
  }, [_c('Select', {
    ref: "selectFromFactory",
    staticStyle: {
      "width": "350px"
    },
    attrs: {
      "filterable": "",
      "remote": "",
      "loading": _vm.fromFactoryLoading,
      "placeholder": "选择工厂"
    },
    model: {
      value: _vm.formItem.fromSemiItem,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "fromSemiItem", $$v);
      },
      expression: "formItem.fromSemiItem"
    }
  }, _vm._l(_vm.produceFactoryList, function (option) {
    return _c('Option', {
      key: option.factory._id,
      staticStyle: {
        "width": "350px"
      },
      attrs: {
        "value": option._id
      }
    }, [_vm._v(_vm._s(option.factory.name))]);
  }), 1)], 1), _c('FormItem', {
    attrs: {
      "label": "母液从生产工厂到本厂的运费",
      "prop": "fromFactoryCost"
    }
  }, [_c('div', {
    staticClass: "transCost"
  }, [_c('InputNumber', {
    attrs: {
      "min": 0
    },
    model: {
      value: _vm.formItem.importSemiTransCost,
      callback: function ($$v) {
        _vm.$set(_vm.formItem, "importSemiTransCost", $$v);
      },
      expression: "formItem.importSemiTransCost"
    }
  })], 1)])], 1) : _vm._e(), _c('FormItem', [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.handleSubmit('formItem');
      }
    }
  }, [_vm._v("创建")])], 1)], 1)], 1)])]);

}
var staticRenderFns = []

export { render, staticRenderFns }